import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function CountdownBar() {
  const [spots, setSpots] = useState<number>(0);
  const [isPulsing, setIsPulsing] = useState(false);
  useEffect(() => {
    // Seed initial value based on current hour to be consistent per session
    const hour = new Date().getHours();
    // Generates a number between 73 and 89
    const seededRandom = hour * 13 % 17;
    const initialSpots = 73 + seededRandom;
    setSpots(initialSpots);
    let timeoutId: NodeJS.Timeout;
    const scheduleNextDecrement = (currentSpots: number) => {
      if (currentSpots <= 12) return; // Never go below 12
      // Random interval between 15s and 45s
      const nextInterval = Math.floor(Math.random() * (45000 - 15000 + 1)) + 15000;
      timeoutId = setTimeout(() => {
        setSpots(prev => {
          const nextSpots = prev > 12 ? prev - 1 : prev;
          // Trigger pulse animation
          if (nextSpots !== prev) {
            setIsPulsing(true);
            setTimeout(() => setIsPulsing(false), 500);
          }
          scheduleNextDecrement(nextSpots);
          return nextSpots;
        });
      }, nextInterval);
    };
    scheduleNextDecrement(initialSpots);
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
  // Don't render until we have a value
  if (spots === 0) return null;
  return <div className="fixed top-0 left-0 right-0 z-40 bg-gradient-to-r from-red-900 via-red-800 to-red-900 text-white font-bold text-center py-2 px-4 text-xs md:text-sm uppercase tracking-wide shadow-lg" data-id="element-1">
      <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-2">
        <AlertTriangleIcon className="w-4 h-4 text-brand-gold" data-id="element-3" />
        <span data-id="element-4">Solo quedan</span>
        <span className={`bg-brand-gold text-brand-bg font-black px-2 py-0.5 rounded inline-block transition-transform duration-300 ${isPulsing ? 'scale-125 shadow-[0_0_15px_rgba(245,158,11,0.8)]' : 'scale-100'}`} data-id="element-5">
          {spots}
        </span>
        <span data-id="element-6">lugares disponibles por hoy...</span>
      </div>
    </div>;
}